import React, { useEffect, useState, useRef  } from "react";
import { auth, db } from "./firebase";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { Link, useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import "./components/Navbar.css";


function Navbar() {
    const [user, setUser] = useState(null);
    const [userData, setUserData] = useState(null);
    const [userRole, setUserRole] = useState(null);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const navigate = useNavigate();
    const dropdownRef = useRef(null);

    useEffect(() => {

        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };

        if (dropdownOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        const unsubscribe = onAuthStateChanged(auth, async (u) => {
            if (u) {
                setUser(u);
                const userRef = doc(db, "users", u.uid);
                const userSnap = await getDoc(userRef);
                if (userSnap.exists()) {
                    setUserData(userSnap.data());
                    setUserRole(userSnap.data().userRole);
                }
            } else {
                setUser(null);
                setUserData(null);
                setUserRole(null);
            }
        });
        return () =>{
            unsubscribe();
            document.removeEventListener("mousedown", handleClickOutside);
        }


    }, [dropdownOpen]);

    const handleLogout = async () => {
        await signOut(auth);
        setDropdownOpen(false);
        setMenuOpen(false);
        navigate("/");
    };

    return (
        <nav className="nav">
            <div className="left">
                <a href="/"><img src="/scrub_logo.png" alt="Scrub Mail logo" width="48px" height="48px" /></a>

                <Link to="/" className="logo">ScrubMail</Link>

{/*                <div className="desktop-only" style={styles.links}>
                    {!user && (
                        <>
                            <Link to="/solutions" style={styles.link}>Solutions</Link>
                            <Link to="/features" style={styles.link}>Features</Link>
                            <Link to="/enterprise" style={styles.link}>Enterprise</Link>
                            <Link to="/pricing" style={styles.link}>Pricing</Link>
                            <Link to="/integrations" style={styles.link}>Integrations</Link>
                            <Link to="/help" style={styles.link}>Help</Link>
                        </>
                    )}
                </div>*/}
            </div>

            <div className="right">

                <div className="desktop-only">
                    {!user && (
                        <>
                            {/*<div className="nav-icon">💸</div>*/}
                            <NavLink to="/" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                <span>Solutions</span>
                            </NavLink>
                            <NavLink to="/features" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                <span>Features</span>
                            </NavLink>
                            <NavLink to="/pricing" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                <span>Pricing</span>
                            </NavLink>
                            <NavLink to="/blogs" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                <span>Blog</span>
                            </NavLink>
                            <NavLink to="/help" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                <span>Feedback</span>
                            </NavLink>
                        </>
                    )}

                </div>
                <div className="desktop-only" style={{ display: "flex", gap: "15px", alignItems: "center" }}>
                    {!user ? (
                        <>
                            {/*<span style={styles.lang}><img src="https://flagcdn.com/us.svg" width="20" alt="EN" /> EN</span>*/}
                            <Link to="/login" className="login">Log In</Link>
                            <Link to="/register" className="signup">Sign Up</Link>
                        </>
                    ) : (
                        <>
                            <NavLink to="/" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                <span>Solutions</span>
                            </NavLink>
                            <NavLink to="/features" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                <span>Features</span>
                            </NavLink>
                            <NavLink to="/pricing" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                <span>Pricing</span>
                            </NavLink>
                            <NavLink to="/blogs" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                <span>Blog</span>
                            </NavLink>
                            {userRole === "admin" && <NavLink to="/create" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>Create Blog</NavLink>}

                            <NavLink to="/help" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                <span>Feedback</span>
                            </NavLink>

                            <Link to="/pricing" className="buyBtn">Buy Credits</Link>
                            <div className="avatarWrapper">
                                <button className="avatarBtn" onClick={() => setDropdownOpen(!dropdownOpen)}>
                                    {user.email[0].toUpperCase()}
                                </button>
                                {dropdownOpen && (
                                    <div ref={dropdownRef} className="dropdown">
                                            <div className="profileHeader">
                                                <div className="avatar">{user.email[0].toUpperCase()}</div>
                                                <div style={{marginTop : "4px"}}>
                                                    <strong>{userData?.name || "User"}</strong>
                                                    <p className="dropdown-text">CREDIT BALANCE</p>
                                                    <p className="dropdown-balance">{userData?.balance ?? 0}</p>
                                                </div>
                                            </div>
                                            <hr />
                                            <Link  to="/profile" className="dropdownLink" onClick={() => setDropdownOpen(false)}>👤 Profile</Link>
                                            <Link to="/terms" className="dropdownLink" onClick={() => setDropdownOpen(false)}>🏢 Terms Of Use</Link>
                                            <Link to="/privacy" className="dropdownLink" onClick={() => setDropdownOpen(false)}>🔌 Privacy Policy</Link>
                                            {/*<Link to="/billing" style={styles.dropdownLink}>💳 Billing</Link>*/}
                                            {/*<Link to="/referrals" style={styles.dropdownLink}>📣 Referrals</Link>*/}
                                            <Link to="/help" className="dropdownLink" onClick={() => setDropdownOpen(false)}>❓ Help</Link>
                                            <div style={{marginLeft : "12px", marginRight : "12px"}}>
                                                <button onClick={handleLogout} className="signout-btn">🚪 Sign Out</button>
                                            </div>
                                            <p></p>
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                </div>

                {/* Mobile hamburger */}
                <button
                    className="mobile-only"
                    onClick={() => setMenuOpen(!menuOpen)}
                    style={{
                        background: "transparent",
                        color: "#000",
                        fontSize: "24px",
                        border: "none",
                        cursor: "pointer",
                    }}
                >
                    ☰
                </button>
            </div>

            {/* Mobile menu */}
            {menuOpen && (
                <div className="mobileMenu">
                    {!user ? (
                        <>
                            <Link to="/solutions" className="mobileLink">Solutions</Link>
                            <Link to="/features" className="mobileLink">Features</Link>
                            <Link to="/pricing" className="mobileLink">Pricing</Link>
                            <Link to="/blogs" className="mobileLink">Blog</Link>
                            <Link to="/help" className="mobileLink">Help</Link>
                            <hr />
                            <Link to="/login" className="login">Log In</Link>
                            <Link to="/register" className="signup">Sign Up</Link>
                        </>
                    ) : (
                        <>
                            <Link to="/pricing" className="mobileLink">Buy Credits</Link>
                            <Link to="/profile" className="mobileLink">Profile</Link>
                            <Link to="/account" className="mobileLink">Account</Link>
                            <Link to="/blogs" className="mobileLink">Blog</Link>
                            <Link to="/billing" className="mobileLink">Billing</Link>
                            <Link to="/help" className="mobileLink">Help</Link>
                            <button onClick={handleLogout} className="signout-btn">Sign Out</button>
                        </>
                    )}
                </div>
            )}
        </nav>
    );
}

// const styles = {
//     nav: {
//         display: "flex",
//         justifyContent: "space-between",
//         alignItems: "center",
//         background: "linear-gradient(to right, #2b1e63, #391a91)",
//         padding: "12px 24px",
//         color: "#fff",
//         position: "relative"
//     },
//     left: {
//         display: "flex",
//         alignItems: "center",
//         gap: "20px",
//     },
//     links: {
//         display: "flex",
//         gap: "15px"
//     },
//     right: {
//         display: "flex",
//         alignItems: "center",
//         gap: "15px"
//     },
//     logo: {
//         fontWeight: "bold",
//         fontSize: "20px",
//         color: "#fff",
//         textDecoration: "none"
//     },
//     link: {
//         color: "#fff",
//         textDecoration: "none",
//         fontSize: "15px"
//     },
//     login: {
//         padding: "10px 26px",
//         border: "1px solid #ccc",
//         borderRadius: "6px",
//         background: "transparent",
//         color: "#fff",
//         textDecoration: "none",
//         fontWeight: "600",
//         fontSize: "1.2rem"
//     },
//     signup: {
//         padding: "10px 26px",
//         borderRadius: "6px",
//         background: "#8c73ff",
//         color: "#fff",
//         textDecoration: "none",
//         fontWeight: "600",
//         fontSize: "1.2rem"
//     },
//     buyBtn: {
//         padding: "10px 16px",
//         backgroundColor: "#dcd3ff",
//         borderRadius: "6px",
//         textDecoration: "none",
//         color: "#391a91",
//         fontWeight: "bold",
//         fontSize: "1.2rem"
//
//     },
//     lang: {
//         display: "flex",
//         alignItems: "center",
//         gap: "6px",
//         fontSize: "14px"
//     },
//     avatarWrapper: {
//         position: "relative"
//     },
//     avatarBtn: {
//         background: "#dcd3ff",
//         color: "#391a91",
//         borderRadius: "50%",
//         width: "36px",
//         height: "36px",
//         border: "none",
//         fontWeight: "bold",
//         fontSize: "16px",
//         cursor: "pointer"
//     },
//     dropdown: {
//         position: "absolute",
//         top: "24px",
//         right: 0,
//         background: "#fff",
//         color: "#000",
//         borderRadius: "8px",
//         boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//         width: "220px",
//         zIndex: 10
//
//     },
//     dropdownLink: {
//         display: "block",
//         padding: "10px 16px",
//         textDecoration: "none",
//         marginLeft: "4px",
//         marginTop: "4px",
//         color: "#333",
//         fontSize: "14px",
//         cursor: "pointer",
//         textAlign: "left"
//     },
//     profileHeader: {
//         display: "flex",
//         gap: "10px",
//         padding: "12px 16px"
//     },
//     avatar: {
//         width: "36px",
//         height: "36px",
//         borderRadius: "50%",
//         background: "#8c73ff",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         color: "#fff",
//         fontWeight: "bold",
//         fontSize: "18px"
//     },
//     mobileMenu: {
//         position: "absolute",
//         top: "60px",
//         right: "0px",
//         width: "100%",
//         background: "#fff",
//         color: "#000",
//         zIndex: 20,
//         padding: "10px",
//         display: "flex",
//         flexDirection: "column",
//         gap: "10px"
//     },
//     mobileLink: {
//         color: "#333",
//         textDecoration: "none",
//         padding: "10px",
//         textAlign: "left",
//         borderBottom: "1px solid #eee",
//         fontSize: "16px"
//     }
// };

export default Navbar;